
export const UNKNOWN = 'Unknown';
export const FETCH_INTERVAL = 1000 * 60;
